import { render, staticRenderFns } from "./eventMessage.vue?vue&type=template&id=ecb4f9d6&scoped=true&"
import script from "./eventMessage.vue?vue&type=script&lang=ts&"
export * from "./eventMessage.vue?vue&type=script&lang=ts&"
import style0 from "./eventMessage.vue?vue&type=style&index=0&id=ecb4f9d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb4f9d6",
  null
  
)

export default component.exports